import React from "react";
import { useLocation, useNavigate  } from "react-router-dom";
import withRouter from '../../../helpers/withRouter';
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { ToggleSidebar } from "../../../redux/actions";
import { useTheme } from "@mui/material/styles";
import {
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  ListItemButton ,
  Collapse,
  IconButton,
  Box,
} from "@mui/material";
//import { makeStyles } from "@mui/styles";
import { getTopItems, bottonItems } from "../../../data/navbar-items";
import MenuOpenIcon from "@mui/icons-material/MenuOpen";
// import SidebarStyles from "../../../styles/jss/components/SidebarStyles";
// import clsx from "clsx";
import { ToggleSidebarItem } from "../../../redux/actions";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { fetchAuthSession } from 'aws-amplify/auth';
import axios from "axios";
import { cfg } from "../../../config";

//const useStyles = makeStyles(SidebarStyles);

const SidebarItems = (props) => {
  const [allowedApplications, setAllowedApplications] = React.useState([]);

  const theme = useTheme();
  //const classes = useStyles();
  const open = useSelector((state) => state.sidebarItems);
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();

  const setOrgData = (org) => {
    // Set allowed aircrafts
    setAllowedApplications(org.data.included_apps);
  }

  React.useEffect(() => {
    // Get org
    fetchAuthSession().then((session) => {
      axios
        .get(`${cfg.apiUrl}/org`, {
          headers: {
            "Content-Type": "application/json",
            Authorization: session.tokens?.idToken,
          },
        })
        .then((resp) => {
          console.log(resp.data)
          setOrgData(resp.data)
        })
        .catch((e) => {
          console.log(e);
        });
    });
  }, []);

  const switchLocation = (to) => {
    if (window.innerWidth < theme.breakpoints.values.sm) {
      navigate(to);
      dispatch(ToggleSidebar());
    } else navigate(to);
  };

  const handleClick = (item) => {
    if (item.to) {
      if (window.innerWidth < theme.breakpoints.values.sm) {
        navigate(item.to);
        dispatch(ToggleSidebar());
      } else navigate(item.to);
    } else {
      if (item.items && item.items.length > 0) {
        dispatch(ToggleSidebarItem(item.title));
      }
    }
  };

  const getList = (item) => {
    const { title, icon, to } = item;
    return (
      <Box key={title}>
        <ListItemButton
          key={title}
          onClick={() => handleClick(item)}
          sx={{
            color: 'white',
            fontWeight: 400,
            '&:hover': {
                color: 'black',
                '& button span': {
                    color: 'black'
                }
            },
            ...(location.pathname === to && { fontWeight: 'bold' })
          }}
        >
          {icon && (
            <ListItemIcon style={{ color: "inherit" }}>
              {icon}
            </ListItemIcon>
          )}
          <ListItemText
            primary={title}
            slotProps={{
              primary : {
                ...(location.pathname === to && { fontWeight: 'bold' })
              }
            }}
          />
          {item.items &&
            item.items.length > 0 &&
            (open.openItems.indexOf(title) > -1 ? (
              <ExpandMoreIcon />
            ) : (
              <ExpandLessIcon />
            ))}
        </ListItemButton >
        {item.items && item.items.length > 0 && (
          <Collapse
            in={open.openItems.includes(item.title)}
            timeout="auto"
            unmountOnExit
          >
            <List component="div" disablePadding>
              {item.items.map((drop) => (
                <ListItemButton
                  key={drop.title}
                  sx ={{
                    color: 'white',
                      '&:hover': {
                          color: 'black',
                          '& button span': {
                              color: 'black'
                          }
                      },
                  }}
                  // slotProps  = {{
                  //   color: 'cyan',
                  //     '&:hover': {
                  //         color: 'darkblue',
                  //         '& button span': {
                  //             color: 'green'
                  //         }
                  //     },
                  //   root: {
                  //     color: 'orange',
                  //     '&:hover': {
                  //         color: 'yellow',
                  //         '& button span': {
                  //             color: 'green'
                  //         }
                  //     }
                  //   }}}
                  // slotProps={{
                  //   root: {
                  //     color: 'white',
                  //     fontWeight: 400,
                  //     '&:hover': {
                  //         color: 'black',
                  //         '& button div span': {
                  //             color: 'black'
                  //         }
                  //     },
                  //     paddingLeft: 50,
                  //     ...(location.pathname === drop.to && { fontWeight: 'bold' })
                  // }}}
                  // className={clsx(classes.menuItems, classes.nested, {
                  //   [classes.selected]: location.pathname === drop.to,
                  // })}
                  onClick={() => switchLocation(drop.to)}
                >
                  <ListItemText
                    primary={drop.title}
                    // sx = {{
                    //   color: 'purple',
                    //   '&:hover': {
                    //       color: 'pink',
                    //       '& button span': {
                    //           color: 'green'
                    //       }
                    //   }
                    // }}
                    slotProps={{
                      // root : {
                      //   color: 'blue',
                      //   '&:hover': {
                      //     color: 'red',
                      //     '& button span': {
                      //         color: 'green'
                      //     }
                      // }},
                      primary : {
                        //color: 'white',
                        fontWeight: 400,
                        // '&:hover': {
                        //   color: 'red',
                        //   '& button span': {
                        //       color: 'green'
                        //   }
                        // },
                        paddingLeft: 4,
                        ...(location.pathname === drop.to && { fontWeight: 'bold' })
                      }
                    }}
                  />
                </ListItemButton >
              ))}
            </List>
          </Collapse>
        )}
      </Box>
    );
  }

  return (
    <Box sx={{ height: '100%' }}>
      <Box sx={{
        display: 'flex',
        alignItems: 'center',
        padding: [0,1], //theme.spacing(0, 1),
        // necessary for content to be below app bar
        minHeight: 64,
        justifyContent: 'space-between',
        // Change this once you have theme grey colors
        backgroundColor: "#1d1d1d",
      }}>
        <Box
          component="img"
          src={"/AeronauticaLight_NoTag.svg"}
          alt="Aeronautica"
          sx={{ maxWidth: 150 }}
        />
        <IconButton
          onClick={() => dispatch(ToggleSidebar())}
          sx={{ color: "white" }}
          size="large">
          <MenuOpenIcon />
        </IconButton>
      </Box>
      <Box sx={{
          height: '90%',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between'
        }}>
        <List sx={{ cursor: 'pointer' }}>
          {getTopItems(allowedApplications).map((item) => {
            return getList(item);
          })}
        </List>
        <List sx={{ cursor: 'pointer' }}>
          {bottonItems.map((item) => {
            return getList(item);
          })}
        </List>
      </Box>
    </Box>
  );
};

export default withRouter(SidebarItems);
